import React, { useState, useEffect } from "react";
import Navbar from "../navbarv2/navbar";


function Checkrights() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchInput, setSearchInput] = useState("");

    const fetchData = (query) => {
        setLoading(true);
        const myHeaders = new Headers();
        myHeaders.append("X-API-KEY", "PJV||2f2ee368bca7ae0df1582003c1");

        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };

        fetch(
            `https://addpaycrypto.com/zoo/zoo-api/service/?service=list_number&ref=${query}`,
            requestOptions
        )
            .then((response) => response.json())
            .then((result) => {
                if (result.status === true) {
                    console.log(result.response);
                    setData(result.response || []);
                    setLoading(false);
                } else {
                    console.log(query);
                    setData([]);
                    setLoading(false);
                }


            })
            .catch((error) => {
                setError(error);
                setLoading(false);
            });
    };

    const handleSearch = () => {
        if (searchInput.trim() === "") return;
        fetchData(searchInput);
    };

    return (
        <div className="App">
            <Navbar />
            <div className="container my-4">
                <h2>ค้นหาสิทธิ์ของคุณ</h2>
                <h2>กิจกรรมลุ้นรับรางวัล วันเด็กแห่งชาติ ปี 2568</h2>
                <div className="container mt-3 text-center fs-10 ">
                    <p className='text-danger'>*****เงื่อนไขหากคุณถูกรางวัล ให้ส่งสลิปการชำระงินเพื่อยืนยันผ่าน line Zoo E-Ticket By @pay หรื่อที่ เพจ facbook:Zoo E-ticket by Addpay ******</p>
                </div>
                <div className="input-group mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="กรอกเลขที่คำสั่งซื้อ"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                    />
                    <button
                        className="btn btn-primary"
                        onClick={handleSearch}
                    >
                        ค้นหา
                    </button>
                </div>

                {loading && <div>Loading...</div>}
                {error && <div className="text-danger">Error: {error.message}</div>}

                {data.length > 0 ? (
                    <div className="row">
                        {data.map((item) => (
                            <div className="col-md-4" key={item.id}>
                                <div className="card mb-3">
                                    <div className="card-body">
                                        <h5 className="card-title">ลุ้นรางวัล: {item.reward_number}</h5>
                                        <p className="card-text">ชื่อ: {item.name}</p>
                                        <p className="card-text">เบอร์โทร: {item.phone_number}</p>
                                        <p className="card-text">วันที่เข้าชม: {item.reward_date}</p>
                                        <p className="card-text text-muted">เลขที่คำสั่งซื้อ: {item.ref}</p>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    !loading &&
                    <div className="text-muted">ไม่มีข้อมูลสำหรับการค้นหา</div>
                )}
            </div>
        </div>
    );
}

export default Checkrights;
